<div class="px-2 sm:px-4 md:px-8 py-6">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-5">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance</mat-icon>
      Banco Plaza Dashboard
    </h1>
    <div class="flex items-center gap-2 flex-wrap">
      <span *ngIf="!healthLoading" class="px-3 py-1 rounded-full text-xs font-bold inline-flex items-center gap-1.5"
        [style.background]="health?.status === 'ok' ? '#f0fdf4' : '#fef2f2'"
        [style.color]="health?.status === 'ok' ? '#15803d' : '#b91c1c'"
        [style.border]="health?.status === 'ok' ? '1px solid #bbf7d0' : '1px solid #fecaca'">
        <span class="health-dot" [class.dot-ok]="health?.status === 'ok'" [class.dot-down]="health?.status !== 'ok'"></span>
        {{ health?.status === 'ok' ? 'Operacional' : 'Degraded' }}
      </span>
      <mat-spinner *ngIf="healthLoading" diameter="20"></mat-spinner>

      <span *ngIf="health?.stage" class="px-2 py-1 rounded-full text-xs font-semibold"
        style="background:#eef2ff; color:#3730a3; border:1px solid #c7d2fe;">
        {{ health?.stage }}
      </span>

      <button type="button" (click)="openConsultaLiqModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #6366f1; border: 1px solid #6366f1; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#eef2ff'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #6366f1;">policy</mat-icon>
        Consultar BCV
      </button>

      <button type="button" (click)="openRegistrarReferenciaModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">post_add</mat-icon>
        Registrar referencia
      </button>

      <button type="button" (click)="abrirMontoMinModal()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #1C593D; border: 1px solid #1C593D; border-radius: 10px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">tune</mat-icon>
        Monto mínimo
      </button>

    </div>
  </div>

  <!-- Cuentas / saldo real banco -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5" *ngIf="!cuentasLoading && cuentas.length > 0">
    <div *ngFor="let acc of cuentas" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 18px; border-bottom: 2px solid #bbf7d0;" class="flex items-center gap-2">
        <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">account_balance</mat-icon>
        <span style="font-size: 0.75rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; color: #374151;">{{ acc.tipoCuenta || 'Cuenta' }}</span>
        <span class="ml-auto px-2 py-0.5 text-xs font-bold rounded-full"
          [style.background]="acc.estatus === 'A' ? '#16a34a' : '#6b7280'"
          style="color: white;">
          {{ acc.estatus === 'A' ? 'Activa' : (acc.estatus === 'T' ? 'No débito' : 'Controlada') }}
        </span>
      </div>
      <div class="p-4">
        <div style="font-size: 0.85rem; font-weight: 600; color: #374151; letter-spacing: 0.5px; font-family: monospace;">{{ acc.numero }}</div>
        <div style="font-size: 0.7rem; color: #9ca3af; margin-bottom: 12px;">{{ acc.moneda || 'VES' }} · Apertura {{ acc.fechaApertura }}</div>
        <div style="border-top: 1px solid #e5e7eb; padding-top: 12px;">
          <div style="font-size: 0.68rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: #9ca3af;">Saldo disponible (real banco)</div>
          <div style="font-size: 1.6rem; font-weight: 800; color: #1e5a3f;">{{ acc.saldoDisponible | number:'1.2-2' }} {{ acc.moneda }}</div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="cuentasLoading" class="flex justify-center py-4 mb-5">
    <mat-spinner diameter="24"></mat-spinner>
  </div>

  <!-- Balance operacional (dual disponible/retenido) + KPIs del día -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-5">
    <!-- Balance operacional -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #eef2ff, #e0e7ff); padding: 14px 18px; border-bottom: 2px solid #c7d2fe;" class="flex items-center gap-2">
        <mat-icon style="color: #4338ca; font-size: 20px; width: 20px; height: 20px;">account_balance_wallet</mat-icon>
        <span style="font-size: 0.85rem; font-weight: 700; color: #312e81;">Balance operacional Aguacate</span>
      </div>
      <div class="p-4" *ngIf="!balanceLoading && balance">
        <div style="background:#f3f4f6; border-radius:10px; padding:10px;">
          <div style="font-size:0.68rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Saldo banco real</div>
          <div style="font-size:1.15rem; font-weight:800; color:#374151;">{{ balance.saldoCuenta | number:'1.2-2' }}</div>
        </div>
      </div>
      <div *ngIf="balanceLoading" class="p-4 flex justify-center">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
      <div *ngIf="!balanceLoading && !balance" class="p-4 text-center text-gray-400 text-sm">Balance no inicializado</div>
    </div>

    <!-- KPIs del día -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #fef3c7, #fde68a); padding: 14px 18px; border-bottom: 2px solid #fcd34d;" class="flex items-center gap-2">
        <mat-icon style="color: #b45309; font-size: 20px; width: 20px; height: 20px;">insights</mat-icon>
        <span style="font-size: 0.85rem; font-weight: 700; color: #78350f;">KPIs del día</span>
      </div>
      <div class="p-4 grid grid-cols-2 sm:grid-cols-5 gap-3" *ngIf="!statsLoading && stats">
        <div style="background:#f0fdf4; border-radius:10px; padding:10px; text-align:center;">
          <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Payins</div>
          <div style="font-size:1.05rem; font-weight:800; color:#15803d;">{{ stats.payins.total }}</div>
          <div style="font-size:0.7rem; color:#15803d;">{{ stats.payins.monto | number:'1.2-2' }}</div>
        </div>
        <div style="background:#fef2f2; border-radius:10px; padding:10px; text-align:center;">
          <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Payouts</div>
          <div style="font-size:1.05rem; font-weight:800; color:#dc2626;">{{ stats.payouts.total }}</div>
          <div style="font-size:0.7rem; color:#dc2626;">{{ stats.payouts.montoEnviado | number:'1.2-2' }}</div>
        </div>
        <div style="background:#fef9c3; border-radius:10px; padding:10px; text-align:center;">
          <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Pendientes BCV</div>
          <div style="font-size:1.05rem; font-weight:800; color:#a16207;">{{ stats.payouts.pending }}</div>
          <div style="font-size:0.7rem; color:#a16207;">{{ stats.payouts.pendingMonto | number:'1.2-2' }}</div>
        </div>
        <div style="background:#f3f4f6; border-radius:10px; padding:10px; text-align:center;">
          <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Aprobados</div>
          <div style="font-size:1.05rem; font-weight:800; color:#374151;">{{ stats.payouts.aprobados }}</div>
          <div style="font-size:0.7rem; color:#15803d;">{{ stats.payouts.aprobadosMonto | number:'1.2-2' }}</div>
        </div>
        <div style="background:#fff7ed; border-radius:10px; padding:10px; text-align:center;"
          [matTooltip]="stats.cargos ? ('Comisiones: ' + stats.cargos.comisiones.total + ' / Impuestos: ' + stats.cargos.impuestos.total + ' / Otros: ' + stats.cargos.otros.total) : ''"
          matTooltipPosition="above" matTooltipTouchGestures="off">
          <div style="font-size:0.62rem; font-weight:600; text-transform:uppercase; color:#9ca3af;">Cargos banco</div>
          <div style="font-size:1.05rem; font-weight:800; color:#c2410c;">{{ stats.cargos?.total || 0 }}</div>
          <div style="font-size:0.7rem; color:#c2410c;">{{ (stats.cargos?.monto || 0) | number:'1.2-2' }}</div>
        </div>
      </div>
      <div *ngIf="statsLoading" class="p-4 flex justify-center">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    </div>
  </div>

  <!-- Error banner -->
  <div *ngIf="healthError" style="display: flex; align-items: center; gap: 8px; background: #fef2f2; padding: 12px 16px; border-radius: 10px; border: 1px solid #fecaca; margin-bottom: 20px;">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #dc2626;">warning</mat-icon>
    <span style="font-size: 0.85rem; font-weight: 600; color: #b91c1c;">{{ healthError }}</span>
  </div>

  <!-- Acciones manuales de crons -->
  <div class="bg-white p-4 sm:p-6 rounded-xl shadow-md border border-gray-100 mb-5">
    <div class="flex items-center gap-2 mb-3">
      <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">play_arrow</mat-icon>
      <span style="font-size: 0.85rem; font-weight: 700; color: #374151;">Triggers manuales</span>
    </div>
    <div class="flex flex-wrap gap-2">
      <button type="button" (click)="forzarPayinSync()" [disabled]="syncing"
        [style.opacity]="syncing ? '0.5' : '1'" [style.cursor]="syncing ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #f0fdf4; color: #1C593D; border: 1px solid #bbf7d0; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;" [class.spin]="syncing">sync</mat-icon>
        Forzar payin sync
      </button>
      <button type="button" (click)="forzarSettlement()" [disabled]="settlementChecking"
        [style.opacity]="settlementChecking ? '0.5' : '1'" [style.cursor]="settlementChecking ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #eef2ff; color: #4338ca; border: 1px solid #c7d2fe; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#e0e7ff'" onmouseout="this.style.background='#eef2ff'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;" [class.spin]="settlementChecking">policy</mat-icon>
        Forzar settlement check
      </button>

      <!-- @disabled F12.1 BACKFILL — código MANTENIDO, oculto por *ngIf -->
      <!-- Re-habilitar: cambiar syncHistoricoHabilitado=true en componente + -->
      <!-- UPDATE parametros SET valor='true' WHERE descripcion='BP_SYNC_HISTORICO_HABILITADO' -->
      <button *ngIf="syncHistoricoHabilitado" type="button" (click)="forzarSyncHistorico()" [disabled]="syncingHistorico"
        [style.opacity]="syncingHistorico ? '0.5' : '1'" [style.cursor]="syncingHistorico ? 'not-allowed' : 'pointer'"
        matTooltip="Solo ejecutar 1 vez post-deploy. Sincroniza meses históricos desde apertura de la cuenta."
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #fff7ed; color: #c2410c; border: 1px solid #fed7aa; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#ffedd5'" onmouseout="this.style.background='#fff7ed'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;" [class.spin]="syncingHistorico">history</mat-icon>
        Sync histórico (temporal)
      </button>
      <!-- Fin bloque @disabled F12.1 -->
      <button type="button" (click)="refreshAll()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">refresh</mat-icon>
        Refrescar todo
      </button>
    </div>
  </div>

  <!-- Cuota diaria USD (cap contractual BP) -->
  <div class="bg-white rounded-xl shadow-md border border-gray-100 mb-5 overflow-hidden">
    <div style="background: #f0f9ff; padding: 12px 16px; border-bottom: 1px solid #bae6fd; display: flex; align-items: center; gap: 8px;">
      <mat-icon style="color: #0369a1; font-size: 20px; width: 20px; height: 20px;">trending_up</mat-icon>
      <span style="font-size: 0.85rem; font-weight: 700; color: #0c4a6e;">Cuota diaria USD (contractual BP)</span>
      <span *ngIf="cuota" style="margin-left: auto; font-size: 0.7rem; color: #64748b;">
        Hora Venezuela
        <ng-container *ngIf="cuota.tasaBcvUsada"> · Tasa BCV: {{ cuota.tasaBcvUsada | number:'1.2-4' }}</ng-container>
      </span>
    </div>
    <div class="p-4" *ngIf="!cuotaLoading && cuota">
      <div class="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <div>
          <span style="font-size: 1.3rem; font-weight: 800; color: #0c4a6e;">
            ${{ cuota.acumuladoUSD | number:'1.2-2' }}
          </span>
          <span style="font-size: 0.85rem; color: #64748b; margin-left: 6px;">
            / ${{ cuota.limiteDiarioUSD | number:'1.0-0' }} USD usados
          </span>
        </div>
        <div>
          <span style="font-size: 0.85rem; color: #64748b;">Disponible: </span>
          <span style="font-size: 1.05rem; font-weight: 700;" [style.color]="getCuotaBarColor()">
            ${{ cuota.disponibleUSD | number:'1.2-2' }}
          </span>
        </div>
      </div>
      <div style="width: 100%; height: 10px; background: #e5e7eb; border-radius: 6px; overflow: hidden;">
        <div [style.width]="(cuota.porcentajeUsado > 100 ? 100 : cuota.porcentajeUsado) + '%'"
             [style.background]="getCuotaBarColor()"
             style="height: 100%; transition: width 0.3s ease, background 0.3s ease;">
        </div>
      </div>
      <div class="flex flex-wrap items-center justify-between gap-2 mt-2">
        <span style="font-size: 0.72rem; color: #64748b;">
          {{ cuota.porcentajeUsado | number:'1.0-2' }}% usado · {{ cuota.operacionesHoy }} operaciones · {{ cuota.totalVesHoy | number:'1.2-2' }} VES
        </span>
        <span *ngIf="cuota.porcentajeUsado >= 90" style="font-size: 0.72rem; font-weight: 700; color: #dc2626;">
          ⚠ Próximo a quedar sin cuota — preparar fallback manual
        </span>
        <span *ngIf="cuota.porcentajeUsado >= 70 && cuota.porcentajeUsado < 90" style="font-size: 0.72rem; font-weight: 700; color: #d97706;">
          ⚠ Cuota alta
        </span>
      </div>
    </div>
    <div *ngIf="cuotaLoading" class="p-6 text-center text-gray-400 text-sm">Cargando cuota…</div>
    <div *ngIf="!cuotaLoading && !cuota" class="p-4 text-center text-gray-400 text-sm">Cuota no disponible</div>
  </div>

  <!-- Filtros de transactions -->
  <div class="bg-white p-4 sm:p-6 rounded-xl shadow-md border border-gray-100 mb-5">
    <div class="flex items-center gap-2 mb-3">
      <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">filter_list</mat-icon>
      <span style="font-size: 0.85rem; font-weight: 700; color: #374151;">Filtros de transacciones</span>
    </div>
    <div class="flex flex-wrap gap-3">
      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Tipo</mat-label>
        <mat-select [(value)]="filterTipo" (selectionChange)="applyFilters()">
          <mat-option value="">Todos</mat-option>
          <mat-option value="PAYIN">Payin</mat-option>
          <mat-option value="PAYOUT">Payout (legacy)</mat-option>
          <mat-option value="PAYOUT_OWNBANK">Payout · Mismo banco</mat-option>
          <mat-option value="PAYOUT_OTHERBANK">Payout · Otro banco</mat-option>
          <mat-option value="PAYOUT_P2P">Payout · Pago Móvil</mat-option>
          <mat-option value="CARGO_BANCARIO">Cargo del banco</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Status</mat-label>
        <mat-select [(value)]="filterStatus" (selectionChange)="applyFilters()">
          <mat-option value="">Todos</mat-option>
          <mat-option value="PENDING">Pending</mat-option>
          <mat-option value="PENDING_BCV">Pending BCV</mat-option>
          <mat-option value="PENDING_VERIFICATION">Verificando</mat-option>
          <mat-option value="APPROVED">Approved</mat-option>
          <mat-option value="REJECTED">Rejected</mat-option>
          <mat-option value="EXPIRED">Expired</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Referencia banco</mat-label>
        <input matInput [(ngModel)]="filterReferencia" (keyup.enter)="applyFilters()" placeholder="ej: 875597">
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Cód banco destino</mat-label>
        <input matInput [(ngModel)]="filterCodBancoDestino" (keyup.enter)="applyFilters()" placeholder="ej: 0102">
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Desde</mat-label>
        <input matInput type="date" [(ngModel)]="filterFechaDesde" (change)="applyFilters()">
      </mat-form-field>

      <mat-form-field appearance="outline" class="modern-field filter-field">
        <mat-label>Hasta</mat-label>
        <input matInput type="date" [(ngModel)]="filterFechaHasta" (change)="applyFilters()">
      </mat-form-field>
    </div>

    <div class="flex flex-wrap gap-2 mt-3">
      <button type="button" (click)="applyFilters()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
        Buscar
      </button>
      <button type="button" (click)="clearFilters()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
        Limpiar
      </button>
      <button type="button" (click)="exportarXls()" [disabled]="exportingXls"
        [style.opacity]="exportingXls ? '0.5' : '1'" [style.cursor]="exportingXls ? 'not-allowed' : 'pointer'"
        matTooltip="Descarga las transacciones que cumplen los filtros actuales como Excel. Solo operadores."
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #ecfeff; color: #155e75; border: 1px solid #a5f3fc; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#cffafe'" onmouseout="this.style.background='#ecfeff'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;" [class.spin]="exportingXls">
          {{ exportingXls ? 'sync' : 'download' }}
        </mat-icon>
        Exportar XLS
      </button>
    </div>
  </div>

  <!-- Transactions -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 20px; border-bottom: 2px solid #bbf7d0;" class="flex items-center justify-between">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">receipt_long</mat-icon>
        <span style="font-size: 1rem; font-weight: 700; color: #1e5a3f;">Transacciones Banco Plaza</span>
      </div>
      <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full">
        {{ txTotal }} registros
      </span>
    </div>

    <div *ngIf="txLoading" class="flex justify-center py-10">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <div *ngIf="!txLoading && transactions.length === 0" class="flex flex-col items-center justify-center py-10 text-gray-400">
      <mat-icon style="font-size: 48px; width: 48px; height: 48px; margin-bottom: 8px;">inbox</mat-icon>
      <p style="font-size: 0.85rem; margin: 0;">No se encontraron transacciones</p>
    </div>

    <div *ngIf="!txLoading && transactions.length > 0">
      <div *ngFor="let tx of transactions" class="tx-row" [ngClass]="getTipoClass(tx.tipo)" (click)="openTransactionDetail(tx)">
        <div class="tx-icon-wrap">
          <mat-icon>{{ getTipoIcon(tx.tipo) }}</mat-icon>
        </div>
        <div class="flex-1 min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <span style="font-size: 0.82rem; font-weight: 700; color: #111827;">
              {{ getTipoLabel(tx.tipo) }}
            </span>
            <span class="px-2 py-0.5 text-xs font-bold rounded-full" [ngClass]="getStatusClass(tx.status)">
              {{ getStatusLabel(tx.status) }}
            </span>
            <span *ngIf="tx.referenciaBanco" style="font-size: 0.72rem; font-family: monospace; color: #6b7280; background: #fffbeb; padding: 2px 8px; border-radius: 6px; border: 1px solid #fde68a;">
              ref: {{ tx.referenciaBanco }}
            </span>
            <span *ngIf="tx.codBancoDestino" style="font-size: 0.7rem; color: #4f46e5; background: #eef2ff; padding: 2px 6px; border-radius: 4px;">
              banco {{ tx.codBancoDestino }}
            </span>
          </div>
          <div style="font-size: 0.78rem; color: #4b5563; margin-top: 3px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {{ tx.concepto || tx.nombreBeneficiario || '—' }}
          </div>
          <div class="flex flex-wrap gap-2 mt-1">
            <span *ngIf="tx.identificacionOrdenante" style="font-size: 0.7rem; color: #6b7280; font-family: monospace;">
              ord: {{ tx.identificacionOrdenante }}
            </span>
            <span *ngIf="tx.identificacionBeneficiario" style="font-size: 0.7rem; color: #6b7280; font-family: monospace;">
              ben: {{ tx.identificacionBeneficiario }}
            </span>
            <span *ngIf="tx.userId" style="font-size: 0.7rem; color: #15803d; font-family: monospace;">
              user: {{ tx.userId }}
            </span>
          </div>
          <!-- Indicador "Acreditado interno BP · email operador" cuando un
               payin coincidió con una ref interna que un operador "quemó"
               desde admin. Espejo del bloque de N58. -->
          <div *ngIf="tx.tipo === 'PAYIN' && tx.isInternalCredit" style="margin-top: 4px; padding: 4px 10px; border-radius: 8px; display: inline-flex; align-items: center; gap: 6px; flex-wrap: wrap; background: #eff6ff; border: 1px solid #bfdbfe;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1d4ed8;">admin_panel_settings</mat-icon>
            <span style="font-size: 0.78rem; font-weight: 700; color: #1d4ed8;">
              Acreditado interno Banco Plaza
            </span>
            <span *ngIf="tx.referenciaOperatorEmail" style="font-size: 0.7rem; color: #1d4ed8; font-family: monospace;">
              · {{ tx.referenciaOperatorEmail }}
            </span>
            <span *ngIf="tx.referenciaTitular" style="font-size: 0.7rem; color: #1d4ed8;">
              · {{ tx.referenciaTitular }}
            </span>
          </div>
        </div>
        <div class="text-right flex-shrink-0">
          <div style="font-size: 0.88rem; font-weight: 700;"
            [ngClass]="tx.tipo === 'PAYIN' ? 'tx-payin-text' : (tx.tipo === 'CARGO_BANCARIO' ? 'tx-cargo-text' : 'tx-payout-text')">
            {{ isDebit(tx.tipo) ? '-' : '+' }}{{ tx.monto | number:'1.2-2' }} {{ tx.moneda }}
          </div>
          <div style="font-size: 0.7rem; color: #9ca3af; margin-top: 2px;">
            {{ tx.createdAt | date:'dd/MM/yyyy HH:mm':'America/Caracas' }}
          </div>
          <!-- Botón Verificar BCV — solo para payouts interbank con referencia.
               Consulta directa al banco; read-only, no modifica el log. -->
          <ng-container *ngIf="puedeVerificarBcv(tx)">
            <div style="margin-top: 6px; display: flex; align-items: center; gap: 6px; justify-content: flex-end;">
              <span *ngIf="bcvVerification[tx.id]?.result || bcvVerification[tx.id]?.error"
                [ngClass]="getBcvBadgeClass(tx.id)"
                [title]="bcvVerification[tx.id]?.desc || bcvVerification[tx.id]?.error || ''"
                style="font-size: 0.68rem; font-weight: 700; padding: 2px 7px; border-radius: 6px; font-family: monospace;">
                {{ getBcvBadgeLabel(tx.id) }}
              </span>
              <button type="button"
                (click)="verificarBcv(tx, $event)"
                [disabled]="bcvVerification[tx.id]?.loading"
                title="Consultar estado real de liquidación BCV al banco (read-only)"
                style="display: inline-flex; align-items: center; gap: 3px; padding: 3px 8px; background: white; color: #6366f1; border: 1px solid #c7d2fe; border-radius: 6px; font-weight: 600; font-size: 0.68rem; cursor: pointer;"
                [style.opacity]="bcvVerification[tx.id]?.loading ? '0.5' : '1'"
                [style.cursor]="bcvVerification[tx.id]?.loading ? 'wait' : 'pointer'">
                <mat-icon style="font-size: 12px; width: 12px; height: 12px;">policy</mat-icon>
                <span *ngIf="!bcvVerification[tx.id]?.loading">Verificar BCV</span>
                <span *ngIf="bcvVerification[tx.id]?.loading">…</span>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div *ngIf="txPages > 1" class="flex items-center justify-center gap-4 py-3 border-t border-gray-100">
      <button type="button" [disabled]="txPage <= 1" (click)="goPage(txPage - 1)"
        [style.opacity]="txPage <= 1 ? '0.4' : '1'" [style.cursor]="txPage <= 1 ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 14px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.78rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">chevron_left</mat-icon>
        Anterior
      </button>
      <span style="font-size: 0.78rem; color: #9ca3af; font-weight: 500;">Página {{ txPage }} de {{ txPages }}</span>
      <button type="button" [disabled]="txPage >= txPages" (click)="goPage(txPage + 1)"
        [style.opacity]="txPage >= txPages ? '0.4' : '1'" [style.cursor]="txPage >= txPages ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 14px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.78rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        Siguiente
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;">chevron_right</mat-icon>
      </button>
    </div>
  </div>

</div>
